import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './footer.css';
import footerLogo from '../../assets/img/newlogo.png';

const Footer = () => {
  const [openSubmenus, setOpenSubmenus] = useState({});

  const toggleSubmenu = (index) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const menuItems = [
    {
      title: 'Motorcycles',
      items: ['Okapi Freedom', 'Pulsar', 'Dominar', 'Avenger', 'Platina', 'CT'],
    },
    {
      title: 'Wheelers & Qute',
      items: ['GoGo', 'E-Tec', 'RE', 'Maxima Z', 'Maxima X Wide', 'Maxima C', 'Qute'],
    },
    {
      title: 'Customer Service',
      items: ["Contact Us", "Spares", "Owner's Manual", "Locate a Dealer"],
    },
    {
      title: 'About Okapi',
      items: ['The Worldâ€™s Favourite Indian', '75 years of Okapi Auto', 'Okapi Team', 'Chairman Emeritus\' Speeches', 'Okapi Auto & KTM', 'About Okapi Group', 'Company Network'],
    },
    {
      title: 'Investors',
      items: ['Investor Relations', 'Financial Performance', 'Stock Exchange Intimations', 'Dividend', 'Policies/Codes', 'Miscellaneous'],
    },
    {
      title: 'Corporate',
      items: ['Media Centre', 'Corporate Social Responsibility', 'Key Policies', 'Code Of Conduct'],
    },
  ];

  const shouldShowSubmenu = (menuIndex, itemIndex) => {
    return (
      menuIndex === 0 || // All items in 'Motorcycles'
      (menuIndex === 1 && (itemIndex === 0 || itemIndex === 1)) // Only 1st and 2nd item in 'Wheelers & Qute'
    );
  };

  return (
    <footer className="Footer-cargo">
      {/* Footer logo Section */}
      <div className="footer-cargo-logo">
        <img src={footerLogo} className="footer-cargologo-img" alt="Footer Logo" />

        {/* Footer Navigation Section */}
        <div className="footer-cargo-nav-container">
          {menuItems.map((menu, menuIndex) => (
            <ul key={menuIndex}>
              <h3>{menu.title}</h3>
              {menu.items.map((item, itemIndex) => {
                const submenuKey =`${menuIndex}-${itemIndex}`
                return (
                  <li
                    key={itemIndex}
                    onClick={() => {
                      if (shouldShowSubmenu(menuIndex, itemIndex)) {
                        toggleSubmenu(submenuKey);
                      }
                    }}
                  >
                    {item}
                    {shouldShowSubmenu(menuIndex, itemIndex) &&
                      openSubmenus[submenuKey] && (
                        <ul className="Bajaj-Freedom">
                          <li>demo</li>
                        </ul>
                      )}
                  </li>
                );
              })} 
            </ul>
          ))}
        </div>
      </div>

      <div className="cargo-copyrights">
        <p>Copyright Â© 2024 Okapi Cargo Ltd. All rights reserved</p>
      </div>
    </footer>
  );
};

export default Footer;